import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import { CountryCode } from '@gql/graphql';
import type {
  HomeLandingGetPopularBreedsQuery,
  HomeLandingGetPopularBreedsQueryVariables,
} from '@gql/graphql';
import { POPULAR_BREEDS } from './constants';

export const HOME_LANDING_GET_POPULAR_BREEDS = graphql(`
  query HomeLandingGetPopularBreeds(
    $where: DogBreedWhereInput
    $breedCardInfoTranslationsWhere: DogBreedTranslationWhereInput
  ) {
    findManyDogBreed(where: $where) {
      ...BreedCardInfo
    }
  }
`);

export const useGetPopularBreeds = () => {
  const { countryCode, language } = useRouter();

  const { data, error, loading } = useQuery<
    HomeLandingGetPopularBreedsQuery,
    HomeLandingGetPopularBreedsQueryVariables
  >(HOME_LANDING_GET_POPULAR_BREEDS, {
    variables: {
      where: {
        id: { in: POPULAR_BREEDS[countryCode] },
      },
      breedCardInfoTranslationsWhere: { language: { equals: language } },
    },
    ssr: false,
  });

  let breeds = data?.findManyDogBreed ? [...data?.findManyDogBreed] : [];
  if (countryCode !== CountryCode.NL) {
    breeds = breeds.sort((a, b) => {
      const indexA = POPULAR_BREEDS[countryCode].indexOf(a.id);
      const indexB = POPULAR_BREEDS[countryCode].indexOf(b.id);
      return indexA - indexB;
    });
  }

  return {
    breeds,
  };
};
